import React, { FC } from 'react';
import { Box, styled } from '@mui/material';
import { Header, SIDEBAR_DESKTOP } from 'dashboard409a/components';
import { useAttioValuationContext } from 'dashboard409a/context/AttioValuationContext';
import { ITheme } from 'theme/types';
import { IMainContainer } from './types';

const RootBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  minHeight: '100vh',
  paddingLeft: SIDEBAR_DESKTOP.width,
  transition: 'background-color 0.2s ease',

  [theme.breakpoints.down('md')]: {
    paddingLeft: 0,
  },
}));

const ContentBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  paddingRight: theme.spacing(4),
  minHeight: 'calc(100vh - 250px)',
  backgroundColor: theme.palette.background.default,
  transition: 'background-color 0.2s ease',
}));

const MainContainer: FC<IMainContainer> = props => {
  const { children, currentCompany, isLoading, navigationItems } = props;
  const { currentAttioCompanyName } = useAttioValuationContext();

  const pageTitle = currentAttioCompanyName || currentCompany?.name || '';

  return (
    <RootBox>
      <Header isLoading={isLoading} navigationItems={navigationItems} pageTitle={pageTitle} />

      <ContentBox>
        {children}
      </ContentBox>
    </RootBox>
  );
};

export default MainContainer;
